export default "__VITE_ASSET__BxRRSLnE__"